import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, faInfoCircle, faExclamationCircle, 
  faCheckCircle, faExclamationTriangle 
} from '@fortawesome/free-solid-svg-icons';
import '../styles/alertModal.css';

export type AlertType = 'info' | 'success' | 'warning' | 'error';

interface AlertModalProps {
  message: string;
  type?: AlertType;
  title?: string;
  onClose: () => void;
}

const AlertModal: React.FC<AlertModalProps> = ({ 
  message, 
  type = 'info', 
  title,
  onClose 
}) => {
  // Determine icon and colors based on alert type
  const getAlertConfig = () => {
    switch (type) {
      case 'success':
        return {
          icon: faCheckCircle,
          color: '#38A169',
          title: title || 'Success',
          buttonClass: 'alertSuccessButton'
        };
      case 'warning':
        return {
          icon: faExclamationTriangle,
          color: '#DD6B20',
          title: title || 'Warning',
          buttonClass: 'alertWarningButton'
        };
      case 'error':
        return {
          icon: faExclamationCircle,
          color: '#E53E3E',
          title: title || 'Error',
          buttonClass: 'alertErrorButton'
        };
      case 'info':
      default:
        return {
          icon: faInfoCircle,
          color: '#3182CE',
          title: title || 'Information',
          buttonClass: 'alertInfoButton'
        };
    }
  };

  const config = getAlertConfig();

  return (
    <div className="alertModalOverlay" onClick={onClose}>
      <div className="alertModalContent" onClick={e => e.stopPropagation()}>
        <button className="alertCloseButton" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        
        <div className="alertIconContainer" style={{ color: config.color }}>
          <FontAwesomeIcon icon={config.icon} size="3x" />
        </div>
        
        <h2 className="alertTitle" style={{ color: config.color }}>{config.title}</h2>
        
        <div className="alertMessage">
          {message}
        </div>
        
        <div className="alertActions">
          <button 
            type="button" 
            className={`alertButton ${config.buttonClass}`}
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal; 